<template>
  <section id="credibility" :class="$style.section">
    <div class="layout-container">
      <div :class="$style.card">
        <h2 :class="$style.title">
          {{ t('myProperties.landing.credibility.title') }}
        </h2>

        <div :class="$style.trustItemsWide">
          <div :class="$style.trustCard">
            <HgIcon :icon="lockIcon" size="2x-large" :color="iconColor" />
            <div :class="$style.itemCopy">
              <p :class="$style.itemTitle">
                {{ t('myProperties.landing.credibility.address.title') }}
              </p>
              <p :class="$style.itemBody">
                {{ t('myProperties.landing.credibility.address.body') }}
              </p>
            </div>
          </div>

          <div :class="$style.trustCard">
            <HgIcon :icon="checkIcon" size="2x-large" :color="iconColor" />
            <div :class="$style.itemCopy">
              <p :class="$style.itemTitle">
                {{ t('myProperties.landing.credibility.free.title') }}
              </p>
              <p :class="$style.itemBody">
                {{ t('myProperties.landing.credibility.free.body') }}
              </p>
            </div>
          </div>
        </div>

        <div :class="$style.trustItemsNarrow">
          <HgAccordion
            id="credibility-address"
            :title="t('myProperties.landing.credibility.address.title')"
          >
            <p :class="$style.itemBody">
              {{ t('myProperties.landing.credibility.address.body') }}
            </p>
          </HgAccordion>
          <HgAccordion
            id="credibility-free"
            :title="t('myProperties.landing.credibility.free.title')"
          >
            <p :class="$style.itemBody">
              {{ t('myProperties.landing.credibility.free.body') }}
            </p>
          </HgAccordion>
        </div>

        <HgAccordion
          id="credibility-why"
          :title="t('myProperties.landing.credibility.why.title')"
          :class="$style.whyAccordion"
        >
          <p :class="$style.itemBody">
            {{ t('myProperties.landing.credibility.why.body', { brand }) }}
          </p>
        </HgAccordion>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { isPlatformHg } from '@/helpers/Platform/Platform';
import { HgAccordion, HgIcon, Icon } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'MyPropertiesCredibilitySection',
});

const { t } = useI18n();

const brand = computed(() => (isPlatformHg() ? 'Homegate' : 'ImmoScout24'));

const lockIcon = Icon.Lock;
const checkIcon = Icon.Check;

const iconColor = computed(() => (isPlatformHg() ? 'secondary' : 'black'));
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.section {
  margin: $space-400 0;
}

.card {
  display: flex;
  flex-direction: column;
  gap: $space-150;
  background-color: var(--theme-color-light);
  border-radius: $border-radius-l;
  box-shadow: $elevation-minimal;
  padding: $space-200 $space-150;

  @include grid-media-query(sm) {
    gap: $space-200;
    padding: $space-300 $space-400;
  }
}

.title {
  @include heading-2;
  margin: 0;
  color: var(--text-color-primary);
  text-align: left;

  @include grid-media-query(sm) {
    text-align: center;
  }
}

.trustItemsWide {
  display: none;

  @include grid-media-query(sm) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $space-150;
    align-items: stretch;
  }
}

.trustCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: $space-100;
  min-width: 0;
  padding: $space-200;
  background-color: $color-grey-30;
  border-radius: $border-radius-l;
}

.trustItemsNarrow {
  display: flex;
  flex-direction: column;
  gap: $space-75;
  padding: $space-100;
  background-color: $color-grey-30;
  border-radius: $border-radius-l;

  @include grid-media-query(sm) {
    display: none;
  }
}

.itemCopy {
  display: flex;
  flex-direction: column;
  gap: $space-50;
  min-width: 0;
}

.itemTitle {
  @include heading-4;
  margin: 0;
  color: var(--text-color-primary);
}

.itemBody {
  @include body-3;
  margin: 0;
  color: var(--text-color-secondary);

  b {
    font-weight: var(--typo-font-weight-semi-bold);
  }
}

.whyAccordion {
  color: var(--text-color-primary);
}
</style>
